import { configureStore, combineReducers } from "@reduxjs/toolkit";
import logger from "redux-logger";
import { useDispatch, useSelector, TypedUseSelectorHook } from "react-redux";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
// 引入每一个reducer
import login from "./modules/login.slice";
import todayData from "./modules/todayData.slice";
import useManagement from "./modules/useManagement.slice";
import globalConstans from "./modules/globalConstans.slice";
import paySetting from "./modules/paySetting.slice";
import systemPay from "./modules/systemPay.slice";
import roleManagement from "./modules/roleManagement.slice";
import rechargeManagement from "./modules/rechargeManagement.slice";
import helpCenter from "./modules/helpCenter.slice";
import noticSlice from "./modules/notic.slice";
import bounsPointsSettingsSlice from "./modules/bounsPointsSettings.slice";
import IntergralWorks from "./modules/IntegralWorks.slice";
import substation from "./modules/substation.slice";

const persistConfig = {
  key: 'root',
  storage,
  // 指定哪些reducer数据持久化 配置白名单
  whitelist: ['login','todayData','useManagement','globalConstans','paySetting','roleManagement','rechargeManagement',
    'helpCenter','noticSlice','bounsPointsSettingsSlice','bonusPointsSettings',],
}
const persistedReducer = persistReducer(
  persistConfig,
  combineReducers({
    login,
    globalConstans,
    todayData,
    useManagement,
    paySetting,
    systemPay,
    roleManagement,
    rechargeManagement,
    helpCenter,
    noticSlice,
    bounsPointsSettingsSlice,
    IntergralWorks,
    substation,
    // 这里放入各个模块
  }),
)
// 将store中的reducer替换成持久化处理后的reducer，并生成库暴露出去
export const store = configureStore({
  reducer: persistedReducer,
  // middleware: (getDefaultMiddleware) => getDefaultMiddleware({}).concat(logger),
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});
// 向外暴露类型
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
// 向外暴露方法
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const persistor = persistStore(store)